export const ORG_AGREEMENT_ACK_VERSION = "org_agreement_ack_v1";

export const ORG_AGREEMENT_ACK_TITLE = "Platform Access";

export const ORG_AGREEMENT_ACK_SECTIONS = [
  {
    heading: "Governing agreements",
    body: "Your use of the platform is governed by the written agreements between your organization and a2z, including any confidentiality, business associate and evaluation agreements. This acknowledgement adds no terms to those agreements and changes none of them.",
  },
];

export const ORG_AGREEMENT_ACK_PREAMBLE =
  'a2z Radiology AI, Inc. ("a2z") provides you access to its platform on behalf of your organization. By clicking "I Accept" below, you confirm that you are using the platform on your organization\'s behalf under its agreements with a2z.';
